<template>
  <el-dialog title="编辑车辆信息" class="global-dialog" :visible.sync="showDlg" width="800px" :before-close="handleClose">
    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        :rules="rules" ref="form3" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="isDepositAmount" label="保证金">
              <el-radio-group :disabled="formData.pickupStatus !== '1'" v-model="formData.isDepositAmount">
                <el-radio label="1">抵货款</el-radio>
                <el-radio label="2">未抵货款</el-radio>
              </el-radio-group>
            </el-form-item>

          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item prop="isGoodsAmount" label="是否超额提货">-->
<!--              是-->
<!--&lt;!&ndash;              <el-radio-group :disabled="!hasCeEdit" v-model="formData.isGoodsAmount">&ndash;&gt;-->
<!--&lt;!&ndash;                <el-radio label="1">是</el-radio>&ndash;&gt;-->
<!--&lt;!&ndash;                <el-radio label="2">否</el-radio>&ndash;&gt;-->
<!--&lt;!&ndash;              </el-radio-group>&ndash;&gt;-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="12">
            <el-form-item prop="isVehicle" label="车辆预约">
              <el-radio-group v-model="formData.isVehicle">
                <el-radio label="1">需要预约</el-radio>
                <el-radio label="2">不需要预约</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateStart" label="可预约日期(开始)">
              <el-date-picker v-model="formData.vehicleDateStart" type="date" value-format="yyyy-MM-dd"
                placeholder="选择可预约日期(开始)">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleDateEnd" label="可预约日期(结束)">
              <el-date-picker v-model="formData.vehicleDateEnd" type="date" value-format="yyyy-MM-dd"
                placeholder="选择可预约日期(结束)">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- 是否预约仅控制预约流程，两种方式都必须选择车辆并保留司机信息。 -->
          <template>
            <el-col :span="12">
              <el-form-item prop="vehicleKey" label="车/船号">
                <el-select v-model="currentVehicleKey" :filterable="true" :clearable="true" placeholder="输入车船号/姓名搜索"
                  @change="carChange">
                  <el-option v-for="(item, index) of carList" :value="`${item.vehicleKey}(${item.driverName})`"
                    :label="`${item.vehicleKey}(${item.driverName})`" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="vehicleGph" label="挂车号">
                <el-input v-model="formData.vehicleGph" :readonly="true" placeholder="请输入挂车号" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverName" label="联系人">
                <el-input v-model="formData.driverName" :readonly="true" placeholder="请输入联系人" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverKey" label="身份证">
                <el-input v-model="formData.driverKey" :readonly="true" placeholder="请输入身份证" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="driverMobile" label="联系电话">
                <el-input v-model="formData.driverMobile" :readonly="true" placeholder="请输入联系电话" clearable></el-input>
              </el-form-item>
            </el-col>
          </template>
          <el-col :span="12">
            <el-form-item prop="vehicleStartAddress" label="卸货库点">
              <el-select v-model="formData.vehicleStartAddress" filterable @change="onVehicleStartAddressChange" placeholder="请选择卸货库点">
                <el-option :value="item.warehouseId" :label="item.warehouseName"
                  v-for="(item, index) of vehicleStartAddressList" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="vehicleEndAddress" label="提货库点">
              <el-input v-model="formData.vehicleEndAddress" placeholder="请输入提货库点" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="fileList" label="附件">
              <file-upload v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="remark" label="备注">
              <el-input v-model="formData.remark" placeholder="请输入备注" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitDlg">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { validPhoneNumber, validIDCard } from '@/utils/validator'
import { deepClone } from '@/utils/utils'
export default {
  name: 'DeliveryCarEditDlg',
  props: {
    showDlg: {
      type: Boolean,
      default: false
    },
    pickupId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      carList: [],
      currentVehicleKey: '',
      vehicleStartAddressList: [],
      formData: {
        pickupId: '',
        pickupStatus: '',
        isDepositAmount: '1',
        isGoodsAmount: '1',
        isVehicle: '',
        vehicleDateStart: '',
        vehicleDateEnd: '',
        vehicleKey: '', // 车牌号
        vehicleGph: '', //  挂车号
        driverName: '', //  司机姓名
        driverKey: '', //  司机身份证
        driverMobile: '', //  司机手机号
        vehicleStartAddress: '',
        vehicleEndAddress: '',
        fileList: [],
        remark: ''
      },
      rules: {
        // 不预约同样校验车辆及司机资料，避免保存空车辆提货单。
        vehicleKey: [
          { required: true, message: '请输入车牌号' }
        ],
        driverName: [
          { required: true, message: '请选择包含司机姓名的车辆' }
        ],
        driverKey: [
          {
            pattern: validIDCard,
            message: '请输入正确的身份证',
            trigger: ['blur', 'change']
          }
        ],
        driverMobile: [
          { required: true, message: '请选择包含司机手机号的车辆' },
          {
            pattern: validPhoneNumber,
            message: '请输入正确的手机号',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false
    }
  },
  created() {
    // this.formData.isDepositAmount = this.isDepositAmount || '2'
    // this.formData.pickupId = this.pickupId || ''
    this.getDetail()
    this.loadDict()
    this.loadCarList()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasCeEdit() {
      return this.buttonList.includes('ceedit')
    },
    hasApproval22() {
      return this.buttonList.includes('cwapproval')
    }
  },
  methods: {
    onVehicleStartAddressChange(val) {
      const data = this.vehicleStartAddressList.find(item => item.warehouseId === val)
      this.formData.vehicleEndAddress = data ? data.warehouseName : ''
    },
    loadCarList() {
      this.$axios.get(this.$apis.carManage.selectWlVehicleInfoByPage).then(res => {
        this.carList = res.list.map(item => {
          return {
            currentVehicleKey: `${item.vehicleKey}(${item.driverName})`,
            ...item
          }
        })
      })
    },
    carChange(val) {
      const carInfo = this.carList.find(item => item.currentVehicleKey === val)
      if (carInfo) {
        this.formData.vehicleKey = carInfo.vehicleKey
        this.formData.driverName = carInfo.driverName
        this.formData.driverMobile = carInfo.driverMobile
        this.formData.vehicleGph = carInfo.vehicleGph
        this.formData.driverKey = carInfo.driverKey
      } else {
        this.formData.vehicleKey = ''
        this.formData.driverName = ''
        this.formData.driverMobile = ''
        this.formData.vehicleGph = ''
        this.formData.driverKey = ''
      }
    },
    loadDict() {
      // this.$axios.get(this.$apis.common.selectDicByList, {
      //   params: { dicType: 'vehicleStartAddress' }
      // }).then(res => {
      //   this.vehicleStartAddressList = res.vehicleStartAddress
      // })
      this.$axios.get(this.$apis.prodManage.selectLyWarehouseByPage).then(res => {
        this.vehicleStartAddressList = res.list
      })
    },
    getDetail() {
      this.loading = true

      this.$axios
        .get(this.$apis.yxcDeliveryOrder.selectYxcPickupOrderByPickupId, {
          params: { pickupId: this.pickupId }
        })
        .then(res => {
          // res.fileList = res.fileList ? res.fileList : []
          // res.recordList = res.recordList ? res.recordList : []
          // res.lockedList = res.lockedList ? res.lockedList : []
          // this.formData = res
          if (res.vehicleKey && res.driverName) {
            this.currentVehicleKey = `${res.vehicleKey}(${res.driverName})`
          }
          this.formData.pickupId = res.pickupId
          this.formData.pickupStatus = res.pickupStatus
          this.formData.isDepositAmount = res.isDepositAmount || '1'
          this.formData.isGoodsAmount = res.isGoodsAmount || '1'
          this.formData.isVehicle = res.isVehicle === '3' ? '2' : (res.isVehicle || '2')
          this.formData.vehicleDateStart = res.vehicleDateStart || ''
          this.formData.vehicleDateEnd = res.vehicleDateEnd || ''
          this.formData.vehicleKey = res.vehicleKey // 车牌号
          this.formData.vehicleGph = res.vehicleGph //  挂车号
          this.formData.driverName = res.driverName //  司机姓名
          this.formData.driverKey = res.driverKey //  司机身份证
          this.formData.driverMobile = res.driverMobile //  司机手机号
          this.formData.vehicleStartAddress = res.vehicleStartAddress || ''
          this.formData.vehicleEndAddress = res.vehicleEndAddress || ''
          this.formData.fileList = res.fileList || []
          this.formData.remark = res.remark || ''
        })

        .finally(() => {
          this.loading = false
        })
    },

    handleClose() {
      this.$emit('closeDlg')
    },

    submitDlg() {
      this.$refs.form3.validate().then(async () => {
        this.loading = true
        const formData = deepClone(this.formData)
        // 如果是修改驳回的单子，那就要增加提示，并且将状态手动修改为1，也就是业务员审核状态
        if (this.formData.pickupStatus === '4') {
          await this.$confirm('流程将重新发起，是否确认提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          formData.pickupStatus = '1'
        }
        const url = this.$apis.yxcDeliveryOrder.updateYxcPlanVehicle
        this.$axios.post(url, formData).then(() => {
          this.$emit('saveSuccess')
          this.handleClose()
        })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
.images-wrap {
  display: flex;
  flex-wrap: wrap;

  .images-box {
    width: 148px;
    height: 148px;
    border: 1px dotted #ddd;
    border-radius: 10px;
    margin-right: 10px;
    position: relative;
    margin-bottom: 10px;

    .close-icon {
      position: absolute;
      top: 0;
      right: 0;
      transform: translate(50%, -50%);
      z-index: 10;
      font-size: 18px;
      color: red;
      cursor: pointer;
    }
  }
}

.uplaod-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
